import { createRouter, createWebHistory } from 'vue-router'
// 首屏关键页直接导入，股权穿透等大页懒加载
import DashboardIndex from '@/views/DashboardIndex.vue'
const ShareholderPenetration = () => import('@/views/ShareholderPenetration.vue')
const DataReport = () => import('@/views/DataReport.vue')
import ChipCost from '@/views/ChipCost.vue'
import ShareholderTrade from '@/views/ShareholderTrade.vue'
import ShareholderUniqueness from '@/views/ShareholderUniqueness.vue'
import UploadShareholder from '@/views/UploadShareholder.vue'
import StockPrice from '@/views/StockPrice.vue'
import RuleIndex from '@/views/RuleIndex.vue'
import RuleSpecial from '@/views/RuleSpecial.vue'
import CoreIndex from '@/views/CoreIndex.vue'
import ControlList from '@/views/ControlList.vue'
import SuspiciousIndex from '@/views/SuspiciousIndex.vue'
import SuspiciousConfirm from '@/views/SuspiciousConfirm.vue'
import PermissionIndex from '@/views/PermissionIndex.vue'
import Feedback from '@/views/Feedback.vue'
import Login from '@/views/Login.vue'
import Maintenance from '@/views/Maintenance.vue'
import { resolveBrandingFromWindow } from '@/config/tenantBranding.js'

const routes = [
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance,
    meta: { title: '系统更新中', requiresAuth: false }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: '登录', requiresAuth: false }
  },
  // 根路径在路由守卫中根据角色权限动态跳转，这里不再静态 redirect
  {
    path: '/',
    name: 'root',
    component: DashboardIndex,
    meta: { title: '数据驾驶舱' }
  },
  {
    path: '/report',
    name: 'data-report',
    component: DataReport,
    meta: { title: '数据报告', parent: '数据驾驶舱' }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    redirect: '/dashboard/penetration',
    component: DashboardIndex,
    meta: { title: '数据驾驶舱' },
    children: [
      { path: 'penetration', name: 'penetration', component: ShareholderPenetration, meta: { title: '股权穿透', parent: '数据驾驶舱' } },
      { path: 'chip', name: 'chip', component: ChipCost, meta: { title: '筹码成本', parent: '数据驾驶舱' } },
      { path: 'trade', name: 'trade', component: ShareholderTrade, meta: { title: '交易趋势', parent: '数据驾驶舱' } },
      { path: 'shareholder-uniqueness', name: 'shareholder-uniqueness', component: ShareholderUniqueness, meta: { title: '股东档案', parent: '股东管理' } }
    ]
  },
  {
    path: '/data',
    name: 'data',
    redirect: '/data/upload-shareholder',
    meta: { title: '助理工作台' },
    children: [
      { path: 'upload-shareholder', name: 'upload-shareholder', component: UploadShareholder, meta: { title: '上传名册', parent: '助理工作台' } },
      { path: '/data/stock-price', name: 'stock-price', component: StockPrice, meta: { title: '股票价格', parent: '助理工作台' } }
    ]
  },
  {
    path: '/rule',
    name: 'rule',
    component: RuleIndex,
    meta: { title: '基础规则', parent: '规则配置' }
  },
  {
    path: '/rule-special',
    name: 'rule-special',
    component: RuleSpecial,
    meta: { title: '特殊规则', parent: '规则配置' }
  },
  {
    path: '/core',
    name: 'core',
    redirect: '/core/index',
    meta: { title: '股东管理' },
    children: [
      { path: 'index', name: 'core-index', component: CoreIndex, meta: { title: '核心股东配置', parent: '股东管理' } },
      { path: 'control-list', name: 'control-list', component: ControlList, meta: { title: '核心股东控制', parent: '股东管理' } }
    ]
  },
  {
    path: '/suspicious',
    name: 'suspicious',
    redirect: '/suspicious/index',
    meta: { title: '股东管理' },
    children: [
      { path: 'index', name: 'suspicious-index', component: SuspiciousIndex, meta: { title: '疑似关联处理', parent: '股东管理' } },
      { path: 'confirm', name: 'suspicious-confirm', component: SuspiciousConfirm, meta: { title: '确认疑似关联', parent: '助理工作台' } }
    ]
  },
  {
    path: '/permission',
    name: 'permission',
    component: PermissionIndex,
    meta: { title: '用户权限', parent: '权限与反馈' }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: { title: '问题反馈', parent: '权限与反馈' }
  },
  {
    path: '/permission/neeq-quote',
    redirect: '/dashboard/penetration'
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

/** 浏览器标签：当前页标题 - 站点名（与各路由 meta.title 配合） */
export function getAppDocumentTitleSuffix() {
  return resolveBrandingFromWindow().productName
}

/** @deprecated 请用 getAppDocumentTitleSuffix() */
export const APP_DOCUMENT_TITLE_SUFFIX = 'DMe'

function syncDocumentTitle(to) {
  const suffix = getAppDocumentTitleSuffix()
  const chain = to.matched.map((r) => r.meta?.title).filter(Boolean)
  const pageTitle = chain.length ? chain[chain.length - 1] : ''
  document.title = pageTitle
    ? `${pageTitle} - ${suffix}`
    : suffix
}

// 简单路由守卫：未登录用户跳转到登录页 + 根据角色权限决定默认首页
const whiteList = ['/login', '/maintenance']

const permissionRouteMap = [
  { code: 'data-report', path: '/report' },
  { code: 'penetration', path: '/dashboard/penetration' },
  { code: 'chip', path: '/dashboard/chip' },
  { code: 'trade', path: '/dashboard/trade' },
  { code: 'shareholder-uniqueness', path: '/dashboard/shareholder-uniqueness' },
  { code: 'upload-shareholder', path: '/data/upload-shareholder' },
  { code: 'stock-price', path: '/data/stock-price' },
  { code: 'core', path: '/core/index' },
  { code: 'rule', path: '/rule' },
  { code: 'rule-special', path: '/rule-special' },
  { code: 'core-control-list', path: '/core/control-list' },
  { code: 'suspicious-push', path: '/suspicious/index' },
  { code: 'suspicious-confirm', path: '/suspicious/confirm' },
  { code: 'permission', path: '/permission' }
]

router.beforeEach((to, from, next) => {
  // 构建时 VUE_APP_MAINTENANCE=true 时，除 /maintenance 外一律进入维护页
  if (process.env.VUE_APP_MAINTENANCE === 'true') {
    if (to.path !== '/maintenance') {
      return next('/maintenance')
    }
    return next()
  }
  if (whiteList.includes(to.path)) {
    return next()
  }
  const raw = localStorage.getItem('currentUser')
  if (!raw) {
    return next('/login')
  }
  // 动态决定根路径跳转到哪个页面（按权限优先级）
  if (to.path === '/' || to.path === '') {
    try {
      const user = JSON.parse(raw)
      const perms = Array.isArray(user.permissions) ? user.permissions : []
      const found = permissionRouteMap.find(item => perms.includes(item.code))
      if (found) {
        return next(found.path)
      }
    } catch (e) {
      // ignore parse error
    }
    // 没有任何可访问页面时，退回登录
    return next('/login')
  }
  next()
})

router.afterEach((to) => {
  syncDocumentTitle(to)
})

export default router
